// client/src/v2/domains/transport/transport.api.js

import { messageForTransportHttpError } from "./transportUserMessage";

export async function fetchTransportRoute(payload) {
  const res = await fetch("/api/transport-route", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  let body = null;
  const contentType = res.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    body = await res.json();
  } else {
    body = await res.text();
  }

  if (!res.ok) {
    const err = new Error(
      (body && typeof body === "object" && body.error) || "Transport API failed"
    );
    err.status = res.status;
    err.body = body;
    err.message = messageForTransportHttpError(err);
    throw err;
  }

  return body;
}
